import clsx from 'clsx';
import { memo } from 'react';

import styles from './PigeonLogo.module.scss';

type PigeonLogoProps = {
    className?: string;
    alt?: string;
    dataTestId?: string;
    decorative?: boolean;
    variant?: 'default' | 'header' | 'hero';
};

const PigeonLogoComponent = ({ className, alt = 'Chattenger pigeon logo', dataTestId, decorative = false, variant = 'default' }: PigeonLogoProps) => (
    <span
        aria-hidden={decorative ? 'true' : undefined}
        aria-label={decorative ? undefined : alt}
        className={clsx(styles.root, variant === 'header' && styles.header, variant === 'hero' && styles.hero, className)}
        data-testid={dataTestId}
        role={decorative ? 'presentation' : 'img'}
    >
        <svg aria-hidden="true" className={styles.glyph} focusable="false" preserveAspectRatio="xMidYMid meet" viewBox="0 0 380.76432 417.945201">
            <g transform="translate(-64.582784,485.959142) scale(0.1,-0.1)">
                <path d="M805 4798c-61-69-125-189-146-278-17-71-17-249 0-320 7-30 30-84 51-120 36-61 58-89 188-240 55-65 64-90 32-90-35 0-60-56-60-134 0-141 58-286 154-382 93-93 344-231 453-249 61-11 73-16 73-30 0-23-20-29-117-35-52-4-98-11-104-17-8-8-8-26 2-65 19-79 35-106 108-181 171-178 342-257 653-303 91-13 153-15 316-10 178 5 203 4 209-9 3-9-4-26-18-41-35-37-217-125-379-184-302-109-822-357-871-416-55-66 248-490 529-740 142-126 374-274 433-274 32 0 48 18 87 95 60 120 194 274 361 417 145 124 242 193 398 281 172 98 269 166 365 255 105 99 168 185 233 317 60 122 92 222 130 413 72 351 95 404 241 549 64 63 93 85 126 93 47 13 188 69 201 80 4 4-23 27-60 51-80 52-172 140-233 223-143 196-315 267-531 222-107-23-171-64-349-221-107-95-148-110-274-102-162 11-410 86-589 179-392 204-1136 824-1437 1197-58 72-108 130-112 131-3 0-32-28-63-62zm3101-1372c38-37 44-49 44-86 0-34-6-48-34-76-38-38-77-44-126-19-81 42-77 139 7 205 38 30 61 25 109-24z" />
            </g>
        </svg>
    </span>
);

PigeonLogoComponent.displayName = 'PigeonLogo';

export const PigeonLogo = memo(PigeonLogoComponent);
